module.exports = __webpack_public_path__ + "static/media/gitTogether-details1.759c584c.png";